export const languageOptions = [
    {
        value: 'en',
        flag: '🇬🇧',
        label: 'English',
    },
    {
        value: 'uk',
        flag: '🇺🇦',
        label: 'Ukrainian',
    },
    {
        value: 'ru',
        flag: '🇷🇺',
        label: 'Russian',
    },
    {
        value: 'de',
        flag: '🇩🇪',
        label: 'German',
    },
    {
        value: 'fr',
        flag: '🇫🇷',
        label: 'French',
    },
];
